var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('GeneralScaffold',[_c('FormModelDisplay',{attrs:{"entity-repository":_vm.labelRepository,"i18n-group":"label"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }